
import React, {FC} from 'react';
import {NavProps} from 'components/Header';
import Group from 'components/Header/MenuNav/Group';
import {useNav} from 'components/Header/navs';

import * as styles from './styles.module.scss';

type GroupsProps = NavProps & {
	children?: (
		groups: React.ReactNode[],
		className: string,
	) => React.ReactNode
};

export const Groups: FC<GroupsProps> = ({nav, children}) => {
	const groups = useNav(nav.name).map((g, i) => (
		<Group nav={nav} group={g} key={i} />
	));

	return (
		<div className={styles.groups} >
			{children && children(groups, styles.groups)}
		</div>
	);
};

